import React from 'react'
import { Link } from 'react-router-dom'
import { showWordsByNumber } from '../../helper/showFirstSixWords';
import { getFileName } from '../../helper/getFileName';
import { formatDate } from '../../helper/formatDate';
const MediaBaseURL = process.env.REACT_APP_BACKEND_API;
const BaseReact = process.env.REACT_APP_BASE_URL;

export default function NewsCard({ item, windowWidtht }) {
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    return (
        <Link to={!!item.link ? item.link : `${BaseReact}/singlePost?id=${item.id}`} target={!!item.link ? '_blank' : '_self'} className="item pointer" >
            <div className="newsCard" style={{height:'unset'}}>
                {item.image &&
                    <div className="newsImageContainer">
                        {item.image &&
                            <img src={MediaBaseURL + item.image} alt="ChangeMe" onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `${BaseReact}/img/whiteFlag.png`;
                                e.target.style.display = 'none'
                            }} />
                        }
                    </div>
                }
                <div className="newsPost" style={item.image ? {height:'unset'} : { width: '100%', justifyContent: 'flex-start' , height:'unset' }}>
                    {item.name &&
                        <div className="newsPostTitle roboto-bold">
                            {item.name}
                        </div>
                    }
                    {item.description &&
                        <div className="newsPostDesc roboto-regular">
                            {item.description}
                        </div>
                    }
                    {item.date &&
                        <div className="newsPostDate roboto-bold">
                            <i className="fa fa-calendar iconRed"></i> <span className="newsDate">
                                {formatDate(item.date)}
                            </span>
                        </div>
                    }
                </div>
            </div>
        </Link>
        // <Link to={item?.link} target='_blank' className='newNewsCard' >
        //     <div draggable='false' className="more_news_image_container  bg-dark h-100 " style={{ aspectRatio: '463 / 780' }}>
        //         <img src={`${MediaBaseURL}${item?.image}`}
        //             alt={getFileName(item?.image)}
        //             style={{ width: '100%',  aspectRatio:'3/4'}}
        //             onError={(e)=>e.target.src = '/img/logo.png'}
        //         />
        //         <div className="more_news_image_overlay"></div>
        //         <div className='moreNewsTextBox pt-1'>
        //             <div draggable='false' className="more_news_post_title text-white rtl " style={{ fontSize: 15, paddingLeft: currentLanguage == 'en' ? 15 : 34, paddingRight: currentLanguage == 'en' ? 34 : 15, bottom: windowWidtht >= 1400 ? '6rem' : windowWidtht >= 500 ? '4.5rem' : windowWidtht >= 424 ? '8rem' : '4.5rem' }}>
        //                 {showWordsByNumber(item?.name, 13)}
        //             </div>
        //             <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 15, alignItems: 'flex-end', marginTop: 0 }}>
        //                 <p draggable='false' className="more_news_post_text text-start text-white" style={{ fontSize: 12, marginTop: 10 }}>
        //                     {item?.formattedDate}
        //                 </p>
        //             </div>
        //         </div>
        //     </div>
        // </Link>
    )
}
